import { useState } from "react";
import api, { downloadTemplate } from "../api";

export default function ImportPage() {
  const [target, setTarget] = useState("companies");
  const [kind, setKind] = useState("cliente");
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!file) return;
    setBusy(true); setResult(null);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("default_kind", kind);
    try {
      const r = await api.post(`/import/${target}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(r.data);
    } catch (e) {
      setResult({ error: e.response?.data?.detail || e.message });
    } finally { setBusy(false); }
  };

  const getTemplate = async () => {
    try { await downloadTemplate(target); }
    catch (e) { alert("Impossibile scaricare il template: " + (e.response?.data?.detail || e.message)); }
  };

  return (
    <div>
      <h1 className="page-title">Import anagrafiche</h1>
      <p className="page-sub">Carica un file CSV o Excel (.xlsx) di clienti o lead</p>

      <div className="panel">
        <div className="grid-2">
          <div className="field"><label>Tipo di anagrafica</label>
            <select value={target} onChange={(e) => setTarget(e.target.value)}>
              <option value="companies">Aziende</option>
              <option value="persons">Persone</option>
            </select>
          </div>
          <div className="field"><label>Tipo predefinito (se non in tabella)</label>
            <select value={kind} onChange={(e) => setKind(e.target.value)}>
              <option value="cliente">Cliente</option>
              <option value="lead">Lead</option>
            </select>
          </div>
        </div>
        <div className="field"><label>File (.csv / .xlsx)</label>
          <input type="file" accept=".csv,.xlsx,.xls" onChange={(e) => setFile(e.target.files[0])} />
        </div>
        <div className="toolbar">
          <button className="btn primary" onClick={submit} disabled={!file || busy}>{busy ? "Importazione…" : "Importa"}</button>
          <button className="btn" onClick={getTemplate}>⬇ Scarica template Excel di esempio</button>
        </div>
        <p className="muted">Scarica il modello già pronto con tutte le colonne e due righe di esempio: compilalo, cancella le righe di esempio e ricaricalo qui.</p>
      </div>

      <div className="panel">
        <h3>Intestazioni riconosciute</h3>
        {target === "companies" ? (
          <p className="muted">Ragione sociale, Tipo, Partita IVA, Codice fiscale, Email, PEC, Telefono, SDI, Indirizzo, Città, Provincia, CAP, Note.</p>
        ) : (
          <p className="muted">Nome, Cognome, Tipo, Email, Telefono, Ruolo, Codice fiscale, Note.</p>
        )}
        <p className="muted">Le maiuscole/minuscole e gli spazi non contano. Le righe senza i campi obbligatori vengono saltate.</p>
      </div>

      {result && (
        <div className="panel">
          <h3>Risultato</h3>
          {result.error ? (
            <p style={{ color: "var(--danger)" }}>{result.error}</p>
          ) : (
            <>
              <p><strong style={{ color: "var(--green)" }}>{result.importati}</strong> importati · <strong>{result.saltati}</strong> saltati</p>
              <p className="muted">Colonne riconosciute: {Object.entries(result.colonne_riconosciute).map(([k, v]) => `${k}→${v}`).join(", ")}</p>
              {result.errori?.length > 0 && (
                <ul className="muted">
                  {result.errori.map((e, i) => <li key={i}>Riga {e.riga}: {e.errore}</li>)}
                </ul>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
